import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=3c89987a&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
import style0 from "./Input.vue?vue&type=style&index=0&id=3c89987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89987a",
  null
  
)

export default component.exports